export class UpdatePosition {
  static readonly type = '[GPS] Update Position';
}
